import { render, staticRenderFns } from "./ProductCatalogue.vue?vue&type=template&id=296612b6&scoped=true&"
import script from "./ProductCatalogue.vue?vue&type=script&lang=js&"
export * from "./ProductCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./ProductCatalogue.vue?vue&type=style&index=0&id=296612b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296612b6",
  null
  
)

export default component.exports